/** @jsxRuntime classic */
import "@iwoca/orion/lib/css/orion.css";
import React from "react";

import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import App from "./App";
import AppErrorBoundary from "./AppErrorBoundary";
import { isIwocaDE } from "./countryHelper";
import { dynamicActivate } from "./il8n";
import "./index.css";
import { installDomMutationGuard } from "./utils/domMutationGuard";

export const getRuntimeEnvironment = () =>
  window.location.host.includes("stage") ? "staging" : "production";
export const getRuntimeCountry = () =>
  window.location.host.includes(".de") ? "de" : "uk";

installDomMutationGuard();

const container = document.getElementById("root");
const root = createRoot(container!);

const I18nApp = () => {
  React.useEffect(() => {
    // With this method we dynamically load the catalogs
    dynamicActivate(isIwocaDE() ? "de" : "en");
  }, []);

  return (
    <BrowserRouter>
      <I18nProvider i18n={i18n}>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </I18nProvider>
    </BrowserRouter>
  );
};

root.render(
  <React.StrictMode>
    <I18nApp />
  </React.StrictMode>,
);
